'use strict';

angular.module('portal.lookup', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // portal routings
            // main lookup page
            .state('portal.menus.lookup', {
                url: '/lookup',
                templateUrl: paths.app + 'lookup/components/lookup/lookup.html',
                controller: 'Lookup',
                params: {
                    review: false,
                    messages: []
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.userlookup', {
                url: '/lookup/user',
                templateUrl: paths.app + 'lookup/components/user-lookup/user-lookup.html',
                controller: 'UserLookup',
                params: {
                    review: false,
                    messages: [],
                    lookup_object: null,
                    priorState: ''
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.userlookupdetail', {
                url: '/lookup/user/detail/:id',
                templateUrl: paths.app + 'lookup/components/user-lookup/user-lookup-detail.html',
                controller: 'UserLookupDetail',
                params: {
                    review: false,
                    messages: [],
                    id: null,
                    user: null,
                    lookup_object: null,
                    priorState: ''
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.servicelookup', {
                url: '/lookup/service',
                templateUrl: paths.app + 'lookup/components/service-lookup/service-lookup.html',
                controller: 'ServiceLookup',
                params: {
                    review: false,
                    messages: [],
                    lookup_object: null,
                    priorState: ''
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.servicelookupdetail', {
                url: '/lookup/service/detail/:id',
                templateUrl: paths.app + 'lookup/components/service-lookup/service-lookup-detail.html',
                controller: 'ServiceLookupDetail',
                params: {
                    review: false,
                    messages: [],
                    id: null,
                    service: null,
                    lookup_object: null,
                    priorState: ''
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.schooldrills', {
                url: '/lookup/schooldrills',
                templateUrl: paths.app + 'lookup/components/fire-drill-lookup/fire-drill-lookup.html',
                controller: 'FireDrillLookup',
                params: {
                    review: false,
                    messages: [],
                    lookup_object: null,
                    priorState: ''
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.vehiclelookup', {
                url: '/lookup/vehicle',
                templateUrl: paths.app + 'lookup/components/lookup/lookup-react.html',
                controller: 'PortalLookup',
                params: {
                    review: false,
                    messages: [],
                    lookup_object: null,
                    priorState: ''
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.vehiclelookupdetail', {
                url: '/lookup/vehicle/detail/:id',
                templateUrl: paths.app + 'lookup/components/lookup/lookup-react.html',
                controller: 'PortalLookup',
                params: {
                    id: null,
                    review: false,
                    messages: [],
                    id: null,
                    service: null,
                    lookup_object: null,
                    priorState: ''
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
    }])
;